module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	resourceData: {
		data: {
			primaryKey: 'mediaID',
			attributes: {}
		}
	},

	methods: {
		dataDealer: function(){
			var media = this.getResourceRegisterContent('enhanced') || {};
			if(media.mediaID){
				this.resourceData = {
					data: {
						primaryKey: 'mediaID',
						attributes: {
							mediaID: media.mediaID
						}
					}
				};
			}
		}
	}
};